module.exports = {
	"CATEGORIES": {
		"CARDS_NEWS": "v2-cards-news",
		"CARDS_CUSTOM": "v2-cards-custom",
		"CARDS_ONLINE_RESOURCE": "v2-cards-online-resource",
		"CARDS_BLOG": "v2-cards-blog",
		"CARDS_LIST": "v2-cards-list",
		"CARDS_EVENT": "v2-cards-event",
		"CARDS_COMMENT": "v2-cards-comment",
		"CARDS_QUOTE": "v2-cards-quote",
		"CARDS_POLL": "v2-cards-poll",
		"CARDS_TWITTER": "v2-cards-twitter",
		"CARDS_INSTAGRAM": "v2-cards-instagram",
		"CAROUSELS": "v2-carousels",
		"ACTIVITY_FEEDS": "v2-feeds-activity",
		"NOTIFICATION_FEEDS": "v2-feeds-notification",
		"COMMUNITY_FEEDS": "v2-feeds-community",
		"CONTENT_FEEDS": "v2-feeds-content",
		"BLOCK_HERO": "v2-block-hero",
		"BLOCK_SLIDER": "v2-block-slider",
		"BLOCK_BANNER": "v2-block-banner",
		"BLOCK_TILED": "v2-block-tiled",
		"NAVIGATION": "v2-navigation",
		"WEB_TAXONOMIES": "v2-web-taxonomies",
		"PAGE_INTERACTIONS": "v2-page-interactions",
		"HOLDS": "v2-holds",
		"DIGITAL_HOLDS": "v2-holds-digital",
		"SHELVES": "v2-shelves",
		"RATINGS": "v2-ccc-ratings",
		"COMMENTS": "v2-ccc-comments",
		"TAGS": "v2-ccc-tags",
		"QUOTATIONS": "v2-ccc-quotations",
		"VIDEOS": "v2-ccc-videos",
		"SIMILAR_TITLES": "v2-ccc-similar-titles",
		"PRIVATE_NOTES": "v2-ccc-private-notes",
		"CONTENT_NOTICES": "v2-ccc-content-notices",
		"AGE_SUITABILITY": "v2-ccc-age-suitability",
		"SUMMARY": "v2-ccc-summary",
		"AVAILABILITY": "v2-availability",
		"CHECKOUTS": "v2-checkouts",
		"SEARCH": "v2-search",
		"SEARCH_RESULTS": "v2-search-results",
		"BROADEN_SEARCH": "v2-search-broaden",
		"EMPTY_SEARCH_RESULTS": "v2-search-empty",
		"SEARCH_AUTOSUGGEST": "v2-search-autosuggest",
		"SEARCH_DID_NOT_FIND": "v2-search-didnt-find",
		"SEARCH_FILTERS": "v2-search-filters",
		"LISTS": "v2-lists",
		"FEATURE_IN_CATALOG": "v2-feature-in-catalog",
		"WHILE_YOU_WAIT": "v2-while-you-wait",
		"FEES": "v2-fees",
		"PATRON_PREFERENCES": "v2-patron-preferences",
		"BIB_FORMAT_CHOOSER": "v2-bib-format-chooser",
		"BIB_COMPONENT": "v2-bib-component",
		"FEATURED_BLOCK": "v2-featured-block"
	},
	"ACTIONS": {
		"CLICK_TITLE": "v2-title-click",
		"CLICK_IMAGE": "v2-image-click",
		"PLAY_VIDEO": "v2-video-play",
		"CLICK_LINK": "v2-link-click",
		"OUTBOUND_LINK_CLICK": "v2-outbound-link-click",
		"PAGE_SCROLL": "v2-scroll",
		"SUBMIT_FORM": "v2-submit",
		"INTERACT_WITH_CONTAINER": "v2-container-interaction",
		"VIEW": "v2-view",
		"DOWNLOAD_A_FILE": "v2-file-download",
		"DOWNLOAD": "v2-download",
		"ADD_CONTENT": "v2-add",
		"EDIT_ITEM": "v2-edit",
		"REMOVE_CONTENT": "v2-remove",
		"MOVE_CONTENT": "v2-move",
		"ADD_ITEM_TO_CONTENT": "v2-add-item",
		"REMOVE_ITEM_FROM_CONTENT": "v2-remove-item",
		"TOGGLE_OPTION": "v2-toggle",
		"TOGGLE_PRIVACY": "v2-toggle-privacy",
		"TOGGLE_VISIBILITY": "v2-toggle-visibility",
		"TOGGLE_OWNERSHIP": "v2-toggle-i-own-this",
		"LIKE_ITEM": "v2-like",
		"DISLIKE_ITEM": "v2-dislike",
		"PAY_FINE": "v2-pay",
		"RENEW_ITEM": "v2-renew",
		"PLACE": "v2-place",
		"CANCEL_HOLD": "v2-cancel",
		"PAUSE_HOLD": "v2-pause",
		"RESUME_HOLD": "v2-resume",
		"RETURN": "v2-return",
		"READ": "v2-read",
		"RESULT": "v2-result",
		"RESULT_DID_YOU_MEAN": "v2-result-did-you-mean",
		"BROADEN": "v2-broaden"
	},
	"LABELS": {
		"OPEN": "open",
		"CLOSE": "close",
		"CONTAINER_TITLE": "title",
		"CONTAINER_FWD_ARROW": "forward-arrow",
		"CONTAINER_BWD_ARROW": "backward-arrow",
		"CONTAINER_DOT_INDICATORS": "dot-indicators",
		"CONTAINER_FWD_SWIPE": "forward-swipe",
		"CONTAINER_BWD_SWIPE": "backward-swipe",
		"CONTAINER_EXPAND": "expand",
		"CONTAINER_COLLAPSE": "collapse",
		"CONTAINER_NEXT_PAGE": "next-page",
		"CONTAINER_PREV_PAGE": "previous-page",
		"CONTAINER_TAB": "tab",
		"CONTAINER_PAGE": "page-{}",
		"CONTAINER_VIEW_ALL": "all-results",
		"CONTAINER_READ_MORE": "read-more",
		"BIB_TITLE": "bib-title",
		"BIB_COVER": "bib-cover",
		"BIB_AUTHOR": "bib-author",
		"BIB_IMAGE": "bib-image",
		"REPORT_THIS": "report-this",
		"TAKE_THE_POLL": "take-the-poll",
		"SKIP_TO_RESULTS": "skip-to-results",
		"JACKET_VIEW_BUTTON": "jacket-view-button",
		"LIST_VIEW_BUTTON": "list-view-button",
		"GROUPED_SEARCH_BUTTON": "grouped-search-button",
		"CHAT_WITH_LIBRARIAN": "chat-with-a-librarian",
		"MODIFY_MY_SEARCH": "modify-my-search",
		"VIEW_MORE_RESOURCES": "view-more-resources",
		"MIXED_TAGS": "mixed-tags"
	},
	"EVENTS": {
		"OPT_IN": "bc.userOptIn",
		"OPT_OUT": "bc.userOptOut",
		"BROADEN_SEARCH": "bc.broadenSearch",
		"SEARCH_RESULTS": "bc.searchResults",
		"SEARCH_VIEW_SELECT": "bc.searchViewSelect",
		"SAVE_SEARCH": "bc.saveSearch",
		"SEARCH_OTHER_RESOURCES_CLICK": "bc.searchOtherResourcesClick",
		"EXTERNAL_SEARCH_CLICK": "bc.externalSearchClick",
		"DID_NOT_FIND_RESOURCE_CLICK": "bc.didNotFindResourceClick",
		"DID_NOT_FIND_SERVICE_CLICK": "bc.didNotFindServiceClick",
		"DID_NOT_FIND_MORE_RESOURCES_CLICK": "bc.didNotFindMoreResourcesClick",
		"DID_NOT_FIND_PANEL_TOGGLE": "bc.didNotFindPanelToggle",
		"CHAT_WITH_LIBRARIAN_CLICK": "bc.chatWithLibrarianClick",
		"MODIFY_SEARCH_CLICK": "bc.modifySearchClick",
		"DYM_SEARCH_RESULT_IMPRESSION": "bc.dymSearchResultImpression",
		"DYM_SEARCH_RESULT_CLICK": "bc.dymSearchResultClick",
		"EMPTY_SEARCH_RESULT": "bc.emptySearchResult",
		"PLACE_HOLD": "bc.placeHold",
		"CANCEL_HOLD": "bc.cancelHold",
		"PAUSE_HOLD": "bc.pauseHold",
		"RESUME_HOLD": "bc.resumeHold",
		"ADD_TO_SHELF": "bc.addToShelf",
		"REMOVE_FROM_SHELF": "bc.removeFromShelf",
		"MOVE_TO_SHELF": "bc.moveToShelf",
		"ADD_RATING": "bc.addRating",
		"EDIT_RATING": "bc.editRating",
		"REMOVE_RATING": "bc.removeRating",
		"ADD_COMMENT": "bc.addComment",
		"EDIT_COMMENT": "bc.editComment",
		"REMOVE_COMMENT": "bc.removeComment",
		"ADD_TAG": "bc.addTag",
		"REMOVE_TAG": "bc.removeTag",
		"ADD_VIDEO": "bc.addVideo",
		"REMOVE_VIDEO": "bc.removeVideo",
		"EDIT_VIDEO": "bc.editVideo",
		"CHECK_AVAILABILITY": "bc.checkAvailability",
		"FORMAT_CHOOSER_SELECTION": "bc.bibFormatChooserSelection",
		"RENEW_CHECKOUT": "bc.renewCheckout",
		"DIGITAL_CHECKOUT": "bc.digitalCheckout",
		"DOWNLOAD_CHECKOUT": "bc.downloadCheckout",
		"READ_CHECKOUT_IN_BROWSER": "bc.readCheckoutInBrowser",
		"RETURN_CHEKOUT": "bc.returnCheckout",
		"TOGGLE_I_OWN_THIS": "bc.toggleIOwnThis",
		"TOGGLE_PRIVACY_EVENT": "bc.togglePrivacy",
		"ADD_QUOTATION": "bc.addQuotation",
		"EDIT_QUOTATION": "bc.editQuotation",
		"REMOVE_QUOTATION": "bc.removeQuotation",
		"ADD_SIMILAR_TITLE": "bc.addSimilarTitle",
		"REMOVE_SIMILAR_TITLE": "bc.removeSimilarTitle",
		"ADD_PRIVATE_NOTE": "bc.addPrivatenote",
		"EDIT_PRIVATE_NOTE": "bc.editPrivatenote",
		"REMOVE_PRIVATE_NOTE": "bc.removePrivatenote",
		"ADD_CONTENT_NOTICE": "bc.addContentnotice",
		"EDIT_CONTENT_NOTICE": "bc.editContentnotice",
		"REMOVE_CONTENT_NOTICE": "bc.removeContentnotice",
		"ADD_AGE_SUITABILITY": "bc.addAgesuitability",
		"EDIT_AGE_SUITABILITY": "bc.editAgesuitability",
		"REMOVE_AGE_SUITABILITY": "bc.removeAgesuitability",
		"ADD_SUMMARY": "bc.addSummary",
		"EDIT_SUMMARY": "bc.editSummary",
		"REMOVE_SUMMARY": "bc.removeSummary",
		"CARD_CLICK": "bc.cardClick",
		"PAGE_INTERACTIONS_BUTTON_CLICK": "bc.pageInteractionsButtonClick",
		"BLOCK_BANNER_CLICK": "bc.blockBannerClick",
		"BLOCK_HERO_CLICK": "bc.blockHeroClick",
		"BLOCK_SLIDER_CLICK": "bc.blockSliderClick",
		"BLOCK_TILED_CLICK": "bc.blockTiledClick",
		"FORM_SUBMISSION": "bc.formSubmission",
		"FILE_DOWNLOAD": "bc.fileDownload",
		"OUTBOUND_LINK": "bc.outboundLinkClick",
		"BIB_TITLE_CLICK": "bc.bibComponentTitleClick",
		"BIB_AUTHOR_CLICK": "bc.bibComponentAuthorClick",
		"BIB_IMAGE_CLICK": "bc.bibComponentImageClick",
		"CAROUSEL_INTERACTION": "bc.carouselInteraction",
		"EVENT_WIDGET_CLICK": "bc.eventWidgetClick",
		"FEATURE_IN_CATALOG_CLICK": "bc.featureInCatalogClick",
		"WHILE_YOU_WAIT_TOGGLE_WIDGET": "bc.whileYouWaitToggleWidget",
		"WHILE_YOU_WAIT_COVER_CLICK": "bc.whileYouWaitCoverClick"
	},
	"CUSTOM_DIMENSIONS": {
		"DIMENSION_MAP": {
			"LIBRARY_ID": "bc.libraryId",
			"SITE_ID": "bc.siteId",
			"BIBLIOWEB_LIBRARY": "bc.cmsEnabled",
			"CONTAINER_NAME": "payload.gtmContainerName",
			"CONTENT_TYPE": "payload.gtmContentType",
			"CONTENT_CREATOR": "payload.gtmContentCreator",
			"CREATOR_TYPE": "payload.gtmCreatorType",
			"CARD_TITLE": "payload.gtmCardTitle"
		},
		"CONTENT_TYPES": {
			"LIST": "list",
			"EVENT": "event",
			"BLOG": "blog",
			"NEWS": "news",
			"FAQ": "faq",
			"TWITTER": "tweet",
			"INSTAGRAM": "instagram",
			"POLL": "poll",
			"ONLINE_RESOURCE": "online-resource",
			"VIDEO": "video",
			"BIB": "bib",
			"COMMENT": "comment",
			"QUOTE": "quote",
			"BIB_TAG": "bib-tag",
			"SUMMARY": "summary",
			"FORM": "form",
			"LOCATION": "location"
		},
		"CREATOR_TYPES": {
			"LIBRARY_STAFF": "library-staff",
			"LIBRARY_PATRON": "library-patron",
			"EXTERNAL_STAFF": "external-staff",
			"EXTERNAL_PATRON": "external-patron",
			"BARCODELESS_USER": "barcodeless-user"
		},
		"CONTAINER_NAMES": {
			"BIB_ITEM": "bib-item",
			"SEARCH_TITLE": "search-title-component",
			"DID_NOT_FIND_PANEL": "didnt-find-panel",
			"DID_NOT_FIND_PANEL_SERVICES": "didnt-find-panel-services",
			"DID_NOT_FIND_PANEL_RESOURCES": "didnt-find-panel-resources"
		}
	},
	"DIGITAL_PROVIDERS": {
		"OverDriveAPI": "OverDrive",
		"BakerAndTaylor": "Axis 360",
		"MMM": "cloudLibrary"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/constants-analytics/lib/constants.json
// module id = 11
// module chunks = 0 2 4 5 6 8 9 10 11